import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { IUBENDA_COOKIE_URL, IUBENDA_PRIVACY_URL } from "@/lib/iubenda";

export default function PolicyPage({ kind }) {
  const [html, setHtml] = useState("");
  const [loading, setLoading] = useState(true);
  const TITLES = { privacy: "Privacy Policy", cookie: "Cookie Policy", terms: "Termini e Condizioni" };
  const title = TITLES[kind] || "Policy";
  const iubendaUrl = kind === "privacy" ? IUBENDA_PRIVACY_URL : kind === "cookie" ? IUBENDA_COOKIE_URL : null;

  useEffect(() => {
    if (iubendaUrl) {
      window.location.replace(iubendaUrl);
      return;
    }
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/policies`)
      .then(r => r.json())
      .then(d => setHtml(kind === "cookie" ? d.cookie_html : kind === "terms" ? d.terms_html : d.privacy_html))
      .catch(() => setHtml("<p>Contenuto non disponibile.</p>"))
      .finally(() => setLoading(false));
  }, [kind, iubendaUrl]);

  return (
    <div className="min-h-screen flex flex-col bg-white" data-testid={`policy-page-${kind}`}>
      <div className="flex-1 max-w-3xl mx-auto w-full px-6 py-12">
        <Link to="/" className="inline-flex items-center gap-1.5 text-[10px] tracking-luxury text-[#707070] uppercase hover:text-[#1A1A1A] mb-6">
          <ArrowLeft className="w-3.5 h-3.5" /> Torna alla home
        </Link>
        <h1 className="font-serif text-4xl mb-8">{title}</h1>
        {iubendaUrl ? (
          <a href={iubendaUrl} className="text-sm underline" data-testid="policy-iubenda-redirect-link">
            Apri {title}
          </a>
        ) : loading ? (
          <div className="text-sm text-[#707070]">Caricamento…</div>
        ) : (
          <div className="prose-rt text-sm leading-relaxed text-[#1A1A1A]"
               data-testid="policy-content"
               dangerouslySetInnerHTML={{ __html: html }} />
        )}
      </div>
    </div>
  );
}
